import {DesignerVersion} from '@mintdata-wsp/common/state/ui/visualDesigner/DesignState';
import {IMigration} from '@mintdata-wsp/wsp/controllers/visualDesigner/designState/DesignMigrationController';
import {AString} from '@mintdata/mint-kit/api/values/AString';
import {Assert} from '@mintdata/mint-kit/impl/util/Assert';

const MIGRATED_VERSION:DesignerVersion = 56;

export const migration_55_56:IMigration = {
    from: MIGRATED_VERSION - 1,
    to: MIGRATED_VERSION,
    migrate: (designState:any) =>
    {
        Assert.yes(designState.designerVersion === MIGRATED_VERSION - 1);

        console.log(`migration ${MIGRATED_VERSION - 1}->${MIGRATED_VERSION} designState`, designState);

        if( designState.surface && designState.surface.pages )
        {
            Object.values(designState.surface.pages).forEach((page:any) =>
            {
                if( page.artboard && page.artboard.allBoxes )
                {
                    Object.values(page.artboard.allBoxes).forEach((boxSnapshot:any) =>
                    {
                        const {component} = boxSnapshot;

                        if( component.name === 'TextArea' )
                        {
                            const {componentDesc} = boxSnapshot;

                            Object.values(componentDesc._properties).forEach((property:any) =>
                            {
                                if( property.name === 'model' )
                                {
                                    property._value = {
                                        ...property._value,
                                        placeholder: migratePlaceholder(property._value.placeholder),
                                    };
                                }
                            });
                        }
                    });
                }
            });
        }

        designState.designerVersion = MIGRATED_VERSION;

        return designState;
    }
};

function migratePlaceholder(oldPlaceholder:any)
{
    return {
        "text": {
            "__type": "STRING",
            "value": oldPlaceholder.value
        },
        "visibility": {
            "__type": "BOOLEAN",
            "value": true
        },
        "font": {
            "typeface": {
                "__type": "STRINGENUM",
                "selectedValue": "Helvetica Neue",
                "values": [
                    "Arial",
                    "Verdana",
                    "Times New Roman",
                    "Helvetica Neue"
                ]
            },
            "weight": {
                "__type": "STRINGENUM",
                "selectedValue": "Regular",
                "values": [
                    "Thin",
                    "Light",
                    "Regular",
                    "Medium",
                    "Bold"
                ]
            },
            "color": {
                "hex": {
                    "__type": "STRING",
                    "value": "#757575"
                },
                "alpha": {
                    "__type": "NUMBER",
                    "value": 1
                }
            },
            "size": {
                "value": {
                    "__type": "NUMBER",
                    "value": 16
                },
                "unitsType": {
                    "__type": "STRINGENUM",
                    "selectedValue": "px",
                    "values": [
                        "px",
                        "%",
                        "auto"
                    ]
                }
            },
            "lineHeight": {
                "value": {
                    "__type": "NUMBER",
                    "value": 18
                },
                "unitsType": {
                    "__type": "STRINGENUM",
                    "selectedValue": "px",
                    "values": [
                        "px",
                        "%",
                        "auto"
                    ]
                }
            },
            "character": {
                "value": {
                    "__type": "NUMBER",
                    "value": 1
                },
                "unitsType": {
                    "__type": "STRINGENUM",
                    "selectedValue": "px",
                    "values": [
                        "px",
                        "%",
                        "auto"
                    ]
                }
            },
            "fontStyle": {
                "__type": "BOOLEAN",
                "value": false
            },
            "decorationUnderline": {
                "__type": "BOOLEAN",
                "value": false
            },
            "decorationCrossed": {
                "__type": "BOOLEAN",
                "value": false
            }
        }
    };
}
